const initialState = {
  isFetching: false,
  isSubmitting: false,
};
const initialStateForTest = {};

export default initialState;
export { initialStateForTest };
